/**
 * Performs a case-insensitive comparison of two given strings.
 */
export function isStringEqual(actual: string, expected: string): boolean {
  return actual.toLowerCase() === expected.toLowerCase()
}
